import {i18n} from '@/lang/lang'
import DataEventService from '@/app-core/lib/services/event/DataEventService'
import DataEventEnum from '@/app-core/lib/services/enum/DataEventEnum'

export default {
  name      : 'LangSwitch',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    size: {
      type   : [String, Number],
      default: '32'
    }
  },
  data() {
    return {}
  },
  computed: {
    routeName() {
      return this.$route.name
    },
    languages() {
      return i18n.languages || []
    },
    activeLanguages() {
      return this.languages.filter(l => l.active && l.visible) || []
    },
    lang() {
      return this.languages.find(l => l.locale === i18n.locale) || {}
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    switchLanguage(lang) {
      DataEventService.Emit(DataEventEnum.EVENT, {
        Event  : DataEventEnum.LOCALE,
        Payload: lang
      })

      setTimeout(() => {
        const r = this.$router.resolve({
          name  : this.$route.name,
          params: {...this.$route.params, ...{lang: lang.locale}},
          query : this.$route.query
        })
        window.location.assign(r.href.replace(/\/+$/, ''))
      }, 100)
    }
  }
}
